<template>
  <v-container fluid class="pa-0">
    <!--TOOLBAR-->
    <v-app-bar flat color="red-darken-3">
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("institutions.label") }}
        <span v-if="institutionCount !== null">({{ institutionCount }})</span>
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <v-text-field
        v-model="search"
        :label="$t('institutions.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn color="grey-darken-4" variant="flat" @click="newInstitution">
        {{ $t("institutions.button") }}
        <v-icon end> mdi-office-building-plus-outline </v-icon>
      </v-btn>
    </v-app-bar>

    <!--ALERT-->
    <v-alert :model-value="alert.value" type="error">
      {{ alert.message }}
    </v-alert>

    <!--EDIT DIALOG-->
    <edit-dialog ref="dialog" @save="getInstitutions" @error="showAlert" />

    <!--EDIT CARS-->
    <edit-cars ref="editCars" />

    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      @edit="editInstitution"
      @cars="editCars"
      @error="showAlert"
      @count="institutionCount = $event"
    />
  </v-container>
</template>

<script>
import Datatable from "@/components/Institutions/datatable.vue";
import Dialog from "@/components/Institutions/dialog.vue";
import Cars from "@/components/Institutions/cars.vue";

export default {
  components: {
    datatable: Datatable,
    "edit-dialog": Dialog,
    "edit-cars": Cars,
  },
  data: () => ({
    search: "",
    institutionCount: null,
    alert: {
      value: false,
      message: "",
    },
  }),
  watch: {
    search: {
      handler(value) {},
      immediate: false,
    },
  },
  mounted() {},
  methods: {
    showAlert(error) {
      this.alert = {
        value: true,
        message: "",
      };
      setTimeout(() => {
        this.alert.value = false;
      }, 2000);
    },
    getInstitutions() {
      const { datatable } = this.$refs;
      datatable.getInstitutions();
    },
    newInstitution() {
      const { dialog } = this.$refs;
      dialog.open(false, {});
    },
    editInstitution(data) {
      const { dialog } = this.$refs;
      dialog.open(true, data);
    },
    editCars(id) {
      const { editCars } = this.$refs;
      editCars.open(id);
    },
  },
};
</script>
